import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import CarSegmentInfoType from "../../types/CarSegmentInfoType";
import DeliveryNotesInfoType from "../../types/DeliveryNotesInfoType";
import DriversType from "../../types/DriversType";
import TransferRequestType from "../../types/TransferRequestType";
import { AutoCompleteOption } from "../common/AutoComplete";
import { CarSegmentInfoDetails } from "./navigationTabs/CarSegmentInfoDetails";
import { DeliveryDetailsTitleNavigation } from "./navigationTabs/DeliveryDetailsTitleNavigation";
import { DeliveryNotesInfoDetails } from "./navigationTabs/DeliveryNotesInfoDetails";
import { DriverDetails } from "./navigationTabs/DriverDetails";
import { TransferRequestDetails } from "./navigationTabs/TransferRequestDetails";
import DeliveryNoteService from "./service/DeliveryNoteServices";
import TransferContext from "../transferReason/TransferContext";

export const DeliveryDetatilsPage = () => {
  const { tenant, userLocations } = useContext(ContextOperation);
  
  const navigate = useNavigate();
  const t = useOperationTranslation();
  
  const [transferRequest, setTransferRequest] = useState<TransferRequestType>();
  const [creationDate, setCreationDate] = useState<string>();
  const [carSegmentInfo, setCarSegmentInfo] = useState<CarSegmentInfoType[]>();
  const [deliveryNotesInfo, setDeliveryNotesInfo] =
    useState<DeliveryNotesInfoType[]>();
  const [drivers, setDrivers] = useState<DriversType[]>();
  const [externalDriver, setExternalDriver] = useState<string>("");
  const { id } = useParams();

  const locations = useMemo<AutoCompleteOption[]>(() => {
    return (
      userLocations.map((loc) => ({
        label: loc.descr || "",
        value: loc.bpCode || "",
      })) || []
    );
  }, [userLocations]);

  useEffect(() => {
    if (!id) return;
    DeliveryNoteService.get.byId(tenant, Number(id)).then((response) => {
      let newStartLocationValue = locations.find(
        (element: any) =>
          element.value === response.transferRequest?.startStationId
      );

      let newExpectedLocationValue = locations.find(
        (element: any) =>
          element.value === response.transferRequest?.expectedEndStationId
      );

      let newEndLocationValue = locations.find(
        (element: any) =>
          element.value === response.transferRequest?.endStationId
      );

      setTransferRequest({
        ...response.transferRequest,
        //startStationDescription: !!newStartLocationValue?.label
        //  ? newStartLocationValue.label
        //  : "",
        //expectedEndStationDescription: !!newExpectedLocationValue?.label
        //  ? newExpectedLocationValue.label
        //  : "",
        //endStationDescription: !!newEndLocationValue?.label
        //  ? newEndLocationValue.label
        //  : "",
        deliveryNoteNumber: response.number,
        externalNumber: response.externalNumber,
      });
      setCarSegmentInfo(response.transferRequest?.carSegmentsInfo);
      setDeliveryNotesInfo(response.deliveryNoteVehicles);
      setDrivers(response.drivers);
      setExternalDriver(response.externalDriver);
      setCreationDate(response.creationDate);
    });
  }, [locations]);

  return (
    <>
      <DeliveryDetailsTitleNavigation transferRequest={transferRequest}/>
      <Mui.Box m={2} p={2} borderColor={"red"} border={1} borderRadius={1}>
        <Mui.Box pb={2}>
          <Mui.Stack direction="row" alignItems="center" gap={1}>
            <Mui.IconButton
              onClick={() => navigate("/operation/transfer/deliveryNotes")}
              color={"primary"}
            >
              <MuiIcons.ArrowBack fontSize="small" />
            </Mui.IconButton>
            <Mui.Typography variant="h5">
              {t("deliveryNote.deliveryDetails.goBackTitle")}
            </Mui.Typography>
          </Mui.Stack>
        </Mui.Box>
        <Mui.Box>
          <Routes>
            <Route
              path="/"
              element={
				<TransferContext>
                  <TransferRequestDetails
                    transferRequest={transferRequest}
                    creationDate={creationDate}
                  />
                </TransferContext>
              }
            />
            <Route
              path="/carsegmentinfo"
              element={
                <CarSegmentInfoDetails carSegmentInfo={carSegmentInfo} />
              }
            />
            <Route
              path="/deliverynotesinfo"
              element={
                <DeliveryNotesInfoDetails
                  deliveryNotesInfo={deliveryNotesInfo}
                />
              }
            />
            <Route
              path="/drivers"
              element={
                <DriverDetails
                  drivers={drivers}
                  externalDriver={externalDriver}
                />
              }
            />
          </Routes>
        </Mui.Box>
      </Mui.Box>
    </>
  );
};
